import React from 'react';
import { Form, Input } from 'components/ds';
import styled from 'styled-components';
import PageContainer from 'modules/account/components/PageContainer/PageContainer';
import { ButtonLarge, FooterDiv } from '../../../../components/Css';
import { useNavigate } from 'react-router-dom';
import routes from 'modules/encapsulation/Routes';

const CustomInput = styled(Input)`
`;

const Invitation: React.FC = () => {
  const [form] = Form.useForm() as any;

  const navigate = useNavigate();

  const handleNext = () => {
    navigate(routes.home.path);
  };

  const submitForm = () => {
    form.submit();
  };

  return (
    <PageContainer title="Digite seu código de convite" navigateBack="/">
      <Form
        form={form}
        layout="vertical"
        onFinish={handleNext}
      >
        <Form.Item
          name="inviteCode"
          rules={[{ required: true, message: 'Por favor, insira seu código de convite!' }]}
        >
          <CustomInput placeholder="Código de convite" size="large" />
        </Form.Item>
      </Form>
      <FooterDiv>
        <ButtonLarge onClick={submitForm}>
          Próximo
        </ButtonLarge>
      </FooterDiv>
    </PageContainer>
  );
};

export default Invitation;
